import { GridFooterCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';
import { getBgColor } from 'src/utils/icons';

const AmountFooterCell = (props: GridFooterCellProps) => {
  const intl = useInternationalization();
  const { totalAmount, errorMessage } = useViewBudgetPeriod();

  return (
    <td className={getBgColor(errorMessage.totalAmount)}>
      <p className="text-right">{intl.format('{0:c2}', totalAmount)}</p>
    </td>
  );
};

export default AmountFooterCell;
